import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  create: { creating: false, success: false },
  update: { creating: false, success: false },
  data: [],
  cabDetails: [],
  weeklyStatements: [],
  monthSummary: {
    monthlyTotalTurnover: 0,
    monthlyCredit: 0,
    monthlyToPay: 0,
    monthlyPaid: 0,
  },
  loading: false,
  error: null,
};
const vehicleMasterSlice = createSlice({
  name: "vehiclemaster",
  initialState,
  reducers: {
    fetchVehicleMasterRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVehicleMasterSuccess(state, action) {
      state.loading = false;
      //   state.data = action.payload;
      state.cabDetails = action.payload.cabDetails;
      state.monthSummary = action.payload.monthSummary;
      state.weeklyStatements = action.payload.weeklyStatements;
    },
    fetchVehicleMasterFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePaidOwnerRequest(state) {
      state.update = { updating: true, success: false };
    },
    updatePaidOwnerSuccess(state: any, action) {
      state.update = { updating: false, success: true };
    },
    updatePaidOwnerFailure(state, action) {
      state.update = { updating: false, success: false };
    },
  },
});
export const {
  fetchVehicleMasterRequest,
  fetchVehicleMasterSuccess,
  fetchVehicleMasterFailure,
  updatePaidOwnerRequest,
  updatePaidOwnerSuccess,
  updatePaidOwnerFailure,
} = vehicleMasterSlice.actions;
export default vehicleMasterSlice.reducer;
